export default {
    name: 'TabResume',
    props: {
        items: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        // Formateamos los datos recibidos desde el componente padre
        itemsFormated() {
            return this.items.map(x => {
                return {
                    uid: x.uuid,
                    status: x.total_mismatched ? 'failed' : 'success',
                    date: x.created_on,
                    total_operations: x.total_operations,
                    updates: x.total_updated,
                    mismatches: x.total_mismatched,
                    imported: x.total_imported,
                    show_details: true
                };
            });
        },
        fields() {
            return ['date', 'total_operations', 'updates', 'imported', 'mismatches', 'show_details'];
        }
    }
};
